import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PlatformMasterDto {
  operationManagerEmail: string;
  operationManagerName: string;
  function: string;
}

export interface PlatformUserRecord {
  id: number;
  operationManagerEmail: string;
  operationManagerName: string;
  function: string;
}

export interface PlatformUsersResponse {
  data: PlatformUserRecord[];
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface PlatformUsersParams {
  page: number;
  pageSize: number;
  email?: string;
  function?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PlatformMasterService {
  private readonly apiUrl = environment.apiUrl + '/digitalplatform';

  constructor(private http: HttpClient) { }

  addPlatform(platformData: PlatformMasterDto): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/add-platform-user`, platformData);
  }

  getDigitalPlatforms(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/get-digital-platforms`);
  }

  getAllPlatformUsers(params: PlatformUsersParams): Observable<PlatformUsersResponse> {
    let httpParams = new HttpParams()
      .set('page', params.page.toString())
      .set('pageSize', params.pageSize.toString());
    if (params.email?.trim()) {
      httpParams = httpParams.set('email', params.email.trim());
    }
    if (params.function?.trim()) {
      httpParams = httpParams.set('function', params.function.trim());
    }
    return this.http.get<PlatformUsersResponse>(`${this.apiUrl}/get-all-platform-users`, { params: httpParams });
  }

  updatePlatformUser(id: number, data: { function: string }): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/update-platform-user`, { id, function: data.function });
  }

  deletePlatformUser(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/delete-platform-user/${id}`);
  }
}
